export const foundUsOptions = [
	{ "label":"Instagram Ad", "value": "instagramAd" },
	{ "label":"Facebook Ad", "value": "facebookAd" },
	{ "label":"Google Ad", "value": "googleAd" },
	{ "label":"Google Search", "value": "googleSearch" },
	{ "label":"Veterinarian", "value": "veterinarian" },
	{ "label":"Emergency Clinic", "value": "emergencyClinic"},
	{ "label":"Groomer", "value": "groomer" },
	{ "label":"Referred by a Friend", "value": "friend" },
	{ "label":"Received a mailer", "value": "mailer" },
	{ "label":"App Store", "value": "appStore" },
	{ "label":"Instagram Account", "value": "instagramAccount" },
	{ "label": "Reddit", "value": "reddit" },
	{ "label": "Snapchat", "value": "snapchat" },
	{ "label":"News", "value": "news" },
	{ "label":"Other", "value": "other" },
];
